// 外部ブラウザでURLを開く共通ユーティリティ
// 優先度: Native bridge (jsCallbackHandler.postMessage) → Android bridge → <a target="_blank">
// 既定ではクエリを付与しない。必要な場合のみ options.appendOpenExternalParam=true を指定
function open(url, options = {}) {
  let externalUrl = url;
  if (options.appendOpenExternalParam) {
    const hasQuery = url.indexOf('?') >= 0;
    externalUrl = url + (hasQuery ? '&' : '?') + 'openExternalBrowser=1';
  }
  // 1) Native bridge（iOS/Android共通ハンドラ）
  try {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.jsCallbackHandler) {
      window.webkit.messageHandlers.jsCallbackHandler.postMessage({ action: 'openExternal', url: externalUrl });
      return;
    }
  } catch (e) {}
  // 2) Android 独自ブリッジ（保険）
  try {
    if (window.android && typeof window.android.openExternal === 'function') {
      window.android.openExternal(externalUrl);
      return;
    }
  } catch (e) {}
  // 3) Fallback: 新規タブ
  const a = document.createElement('a');
  a.href = externalUrl;
  a.target = '_blank';
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export default { open }




// WEBPACK FOOTER //
// ./src/model/openExternalBrowser.js